<template>
  <div>
    <sFormItem
      prop="GeneratingReportId"
      :rules="rules.GeneratingReportId">
      <sSelect
        class="width-100 mt-1"
        clearable
        data-qa="condition-props-list"
        :disabled="disabled || loading"
        filterable
        :loading="loading"
        :placeholder="$t('Common.Select')"
        :value="valueMutable.GeneratingReportId"
        @update:value="sendGeneratingReportId('GeneratingReportId', $event)">
        <sOption
          v-for="reportItem in reports"
          :key="`tender-contact-${reportItem.id}`"
          :data-qa="`tender-contact-${reportItem.id}`"
          :disabled="disabled"
          :label="reportItem.name"
          :value="reportItem.id"/>
      </sSelect>
    </sFormItem>
    <sFormItem
      prop="reportProps"
      :rules="rules.reportProps">
      <sCheckbox
        v-for="(reportProp, reportPropIndex) in reportProps"
        :key="reportProp.key"
        class="ml-1 width-100"
        :class="{'mt-2' : reportPropIndex !== 0 }"
        :label="$t(reportProp.key)"
        :value="reportProp.value"
        @change="sendGeneratingReportId(reportProp.key, $event)"/>
    </sFormItem>
  </div>
</template>
<script>
import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

/**
 * формирование отчета в автоматизации
 */
export default {
  name: 'generateReport',
  data() {
    const that = this
    return {
      rules: {
        GeneratingReportId: {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that.valueMutable?.GeneratingReportId?.trim()) {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          },
        },
        reportProps: {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            let isEmpty = !that.reportProps?.find(i => i.value)
            if (isEmpty) {
              callback(new Error(that.$t('Tenders.NeedCheckMinOne')))
            }
            callback()
          },
        }
      },
      reports: [],
      loading: true,
    }
  },
  methods: {
    sendGeneratingReportId(key, props) {
      const result = this.$_.cloneDeep(this.value)
      const parameters = this.$_.cloneDeep(this.valueMutable)

      parameters[key] = props
      result.parameters = JSON.stringify(parameters)

      this.$emit('update:value', result)
    }
  },
  computed: {
    reportProps() {
      return [
        { key: 'IsNeedToSendEmailToTheMainContact', value: this.valueMutable.IsNeedToSendEmailToTheMainContact },
        { key: 'IsNeedToAddDocumentToTenderAsInternalAttachment', value: this.valueMutable.IsNeedToAddDocumentToTenderAsInternalAttachment },
        { key: 'IsNeedToAddDocumentToTenderAsPublicAttachment', value: this.valueMutable.IsNeedToAddDocumentToTenderAsPublicAttachment }
      ]
    },
    valueMutable: {
      get() {
        const defaultModel = {
          GeneratingReportId: null,
          IsNeedToSendEmailToTheMainContact: false,
          IsNeedToAddDocumentToTenderAsInternalAttachment: false,
          IsNeedToAddDocumentToTenderAsPublicAttachment: false
        }
        if (!this.value?.parameters) {
          return defaultModel
        }
        try {
          return JSON.parse(this.value.parameters) || {}
        } catch {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('Automation.ErrorActionParams'),
            showClose: true,
            progress: true,
          })
          return defaultModel
        }
      },
    },
  },
  async created() {
    await api.getOrganizationReports()
      .then(res => {
        if ( res ) {
          this.reports = res
        }
      })
      .finally(() => {
        this.loading = false
      })
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    additionalProps: {
      type: [Object, Array]
    },
  },
  i18n: {
    messages: {
      uk: {
        IsNeedToSendEmailToTheMainContact: 'Надіслати звіт контактній особі на email',
        IsNeedToAddDocumentToTenderAsInternalAttachment: 'Додати до внутрішніх документів тендера',
        IsNeedToAddDocumentToTenderAsPublicAttachment: 'Додати до зовнішніх документів тендера',
      },
      ru: {
        IsNeedToSendEmailToTheMainContact: 'Отправить в email контактному лицу',
        IsNeedToAddDocumentToTenderAsInternalAttachment: 'Добавить во внутренние документы тендера',
        IsNeedToAddDocumentToTenderAsPublicAttachment: 'Добавить в публичные документы тендера',
      },
      en: {
        IsNeedToSendEmailToTheMainContact: 'Send in email to the contact person',
        IsNeedToAddDocumentToTenderAsInternalAttachment: 'Add to internal tender documents',
        IsNeedToAddDocumentToTenderAsPublicAttachment: 'Add to public tender documents',
      },
    }
  }
}
</script>
